import { Url } from '../../types';
import { triggerSchema } from '../models/trigger.schema';

export const get = (triggerUrl: Url) => {
  return {
    endpoint: triggerUrl,
    method: 'GET',
    responseSchema: triggerSchema,
  } as const;
};
